import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { PrivateRoute } from '../components/PrivateRoute';
import { PrivateLayout, PublicLayout } from '../layouts';

import routes, { LOGIN_ROUTE } from './routes';

const publicPaths = routes.public.map((route) => route.path);
const privatePaths = routes.private.map((route) => route.path);

export function Pages() {
  return (
    <Switch>
      <Route exact path={publicPaths}>
        <PublicLayout>
          <Switch>
            {routes.public.map((route) => (
              <Route key={route.path} exact {...route} />
            ))}
          </Switch>
        </PublicLayout>
      </Route>

      <Route exact path={privatePaths}>
        <PrivateLayout>
          <Switch>
            {routes.private.map((route) => (
              <PrivateRoute key={route.path} redirectTo={LOGIN_ROUTE} exact {...route} />
            ))}
          </Switch>
        </PrivateLayout>
      </Route>

      {routes.redirectTo && <Redirect to={routes.redirectTo} />}
    </Switch>
  );
}
